import { t } from "@/i18n-js/instance";
import { planFeatures } from "@/react/helpers/plansHelpers";
import { usePlans } from "@circle-react/components/SettingsApp/Plan/RegularPlan/PlansContext";
import { FeatureRow } from "../FeatureRow";
import { PlanFeatureFlag } from "../PlanFeatureFlag";
import { SectionWrapper } from "./SectionWrapper";

export const Characteristics = () => {
  const { currentPlan } = usePlans();

  const renderCoursesFeature = (currentPlan: any) => {
    const courseTitle = {
      title: t("pricing_plans.feature.courses"),
    };

    if (currentPlan.show_pro_grandfathered_for_courses) {
      return (
        <FeatureRow
          {...courseTitle}
          basic={false}
          professional
          business
          enterprise
        />
      );
    }
    return <PlanFeatureFlag {...courseTitle} feature={planFeatures.courses} />;
  };

  return (
    <SectionWrapper sectionName={t("pricing_plans.section.features")}>
      <PlanFeatureFlag
        title={t("pricing_plans.feature.custom_domain")}
        feature={planFeatures.custom_domain}
      />
      <FeatureRow
        title={t("pricing_plans.feature.private_spaces")}
        basic
        professional
        business
        enterprise
      />
      <FeatureRow
        title={t("pricing_plans.feature.bulk_import_export")}
        basic
        professional
        business
        enterprise
      />
      <FeatureRow
        title={t("pricing_plans.feature.notifications")}
        basic
        professional
        business
        enterprise
      />
      <FeatureRow
        title={t("pricing_plans.feature.member_profiles_directory")}
        basic
        professional
        business
        enterprise
      />

      <FeatureRow
        title={t("pricing_plans.feature.moderation_basic")}
        basic
        professional
        business
        enterprise
      />
      <FeatureRow
        title={t("pricing_plans.feature.direct_messaging")}
        basic
        professional
        business
        enterprise
      />
      <FeatureRow
        title={t("pricing_plans.feature.group_chat")}
        basic
        professional
        business
        enterprise
      />
      <FeatureRow
        title={t("pricing_plans.feature.email_digest")}
        basic
        professional
        business
        enterprise
      />
      <FeatureRow
        title={t("pricing_plans.feature.events")}
        basic
        professional
        business
        enterprise
      />
      <FeatureRow
        title={t("pricing_plans.feature.gdpr_compliant")}
        basic
        professional
        business
        enterprise
      />
      <FeatureRow
        title={t("pricing_plans.feature.ios_app")}
        basic
        professional
        business
        enterprise
      />
      <FeatureRow
        title={t("pricing_plans.feature.chat_spaces")}
        basic
        professional
        business
        enterprise
      />
      <FeatureRow
        title={t("pricing_plans.feature.scheduled_posts")}
        basic
        professional
        business
        enterprise
      />
      <FeatureRow
        title={t("pricing_plans.feature.gamification")}
        basic
        professional
        business
        enterprise
      />
      <PlanFeatureFlag
        title={t("pricing_plans.feature.custom_snippets")}
        feature={planFeatures.custom_css}
      />
      <PlanFeatureFlag
        title={t("pricing_plans.feature.zapier")}
        feature={planFeatures.zapier_token_automatic_creation}
      />
      <FeatureRow
        title={t("pricing_plans.feature.integrately")}
        basic={false}
        professional={false}
        business
        enterprise
      />
      <FeatureRow
        title={t("pricing_plans.feature.embed")}
        basic={false}
        professional
        business
        enterprise
      />
      <FeatureRow
        title={t("pricing_plans.feature.white_labelling")}
        basic={false}
        professional
        business
        enterprise
      />
      <PlanFeatureFlag
        title={t("pricing_plans.feature.moderation_automated")}
        feature={planFeatures.automated_moderation}
      />
      <PlanFeatureFlag
        title={t("pricing_plans.feature.advanced_reporting")}
        feature={planFeatures.advanced_reporting}
      />
      <FeatureRow
        title={t("pricing_plans.feature.color_themes")}
        basic={false}
        professional
        business
        enterprise
      />

      {renderCoursesFeature(currentPlan)}

      <PlanFeatureFlag
        title={t("pricing_plans.feature.conversion_tracking_code")}
        feature={planFeatures.paywall_conversion_tracking_code}
      />

      <FeatureRow
        title={t("pricing_plans.feature.automated_workflows")}
        basic={false}
        professional={false}
        business
        enterprise
      />

      <PlanFeatureFlag
        title={t("pricing_plans.feature.custom_profile_fields")}
        feature={planFeatures.profile_fields_enabled}
      />

      <FeatureRow
        title={t("pricing_plans.feature.sender_email_customization")}
        basic={false}
        professional={false}
        business
        enterprise
      />

      <PlanFeatureFlag
        title={t("pricing_plans.feature.affiliates")}
        feature={planFeatures.affiliates}
      />

      <PlanFeatureFlag
        title={t("pricing_plans.feature.analytics_filtering")}
        feature={planFeatures.analytics_filters}
      />
    </SectionWrapper>
  );
};
